import { FormLabel, styled } from "@mui/material";

export const Label = styled(FormLabel)`
  font-weight: 600;
  font-size: 14px;
  margin: 2px 5px;
`;
